import {Component, Input} from '@angular/core'

@Component({
  selector: 'dmmp-thanks-you-page',
  templateUrl: './thanks-you-page.component.html'
})
export class ThanksYouPageComponent {
  @Input() data
  @Input() name
}
